import React, { memo, useCallback } from 'react';

import { ListItem, ListItemIcon, ListItemText } from '../../material-ui/List';

export const SidebarItem = memo(({ value, onClick, className, primary, children, selected, textClassName, iconClassName }) => {
    const handleClick = useCallback(() => {
        onClick(value);
    }, [onClick]);

    return (
        <ListItem onClick={handleClick} className={className} button={true} selected={selected}>
            <ListItemIcon className={iconClassName}>{children}</ListItemIcon>
            <ListItemText primary={primary} className={textClassName} />
        </ListItem>
    );
});
